import { first } from 'rxjs/operators';
import { ImageModel } from '../model/image.model';
import { Injectable } from '@angular/core';
import { ReportsService } from './reports.service';

@Injectable({
  providedIn: 'root'
})

export class ReportImageService {
  constructor(private reportsService: ReportsService) {
  }

  getReportImagesOfDivisions(): ImageModel[] {

    const reportImages: ImageModel[] = [];
    this.reportsService.getDivisions().pipe(first()).subscribe(divisionsContainer => {

      divisionsContainer._Divisions.forEach(item => {
        switch (item.Name) {
          case 'Dynamics':
            reportImages.push(new ImageModel(item.Name, 'assets/images/Dynamics.png'));
            break;
          case 'Gas':
            reportImages.push(new ImageModel(item.Name, 'assets/images/Gas.png'));
            break;
          case 'Strom':
            reportImages.push(new ImageModel(item.Name, 'assets/images/Strom.png'));
            break;
          default:
            reportImages.push(new ImageModel(item.Name, 'assets/images/Dynamics.png'));
            break;
        }
      });
    });
    return reportImages;
  }

}
